import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Arrow from './arrow.svg';
import Styles from './Panel.module.scss';

const Panel = ({
  heading,
  children,
  actions,
  footnote,
  withArrow,
  showFootnote,
  className
}) => {
  return (
    <div className={classNames(Styles.panel, className)}>
      {heading && (
        <div className={Styles.heading}>
          <div className={Styles.left}>
            {heading.number && <span>{heading.number}</span>}
            {heading.title ? heading.title : heading}
          </div>
          <div className={Styles.right}>{actions}</div>
        </div>
      )}
      <div className={Styles.content}>{children}</div>
      {showFootnote && <div className={Styles.footnote}>{footnote}</div>}

      {withArrow && <img className={Styles.arrow} alt="arrow" src={Arrow} />}
    </div>
  );
};

Panel.propTypes = {
  heading: PropTypes.oneOfType([
    PropTypes.shape({
      text: PropTypes.string,
      number: PropTypes.number
    }),
    PropTypes.string
  ]),
  children: PropTypes.any,
  withArrow: PropTypes.bool,
  showFootnote: PropTypes.bool,
  actions: PropTypes.element,
  footnote: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string
};

Panel.defaultProps = {
  footnote: '',
  withArrow: false,
  showFootnote: true
};

export default Panel;
